import { Bracket, BracketSeries, GameId } from "@portal-frontend-ssr/blast-api";
import { ClientOnly } from "remix-utils/client-only";
import { TeamSlot } from "~/routes/_cs.cs.bounty-simulator._index/components/TeamDropdown";
import { Accordion, ContentWrapper, Header, Icon } from "~/shared/components/Accordion";
import { getDateRangeLabel } from "../../helpers/getDateRangeLabel";
import { AFLFinalEight } from "./PlayoffBracketComponents/AFLFinalEight";
import { DoubleElim10Skewed } from "./PlayoffBracketComponents/DoubleElim10Skewed";
import { DoubleElim12Skewed } from "./PlayoffBracketComponents/DoubleElim12Skewed";
import { DoubleElim16Skewed } from "./PlayoffBracketComponents/DoubleElim16Skewed";
import { DoubleElim4Skewed } from "./PlayoffBracketComponents/DoubleElim4Skewed";
import { DoubleElim8 } from "./PlayoffBracketComponents/DoubleElim8";
import { DoubleElim8Groups } from "./PlayoffBracketComponents/DoubleElim8Groups";
import { DoubleElim8Skewed } from "./PlayoffBracketComponents/DoubleElim8Skewed";
import { GenericPlayoffBracket } from "./PlayoffBracketComponents/GenericPlayoffBracket";
import { Gsl8 } from "./PlayoffBracketComponents/Gsl8";
import { SingleElim32Bounty } from "./PlayoffBracketComponents/SingleElim32Bounty";
import { SingleElim8Bounty } from "./PlayoffBracketComponents/SingleElim8Bounty";
export const PlayoffBracket = ({
  bracket,
  shouldBracketExpand,
  tournamentId,
  gameId,
  onTeamClick,
  pickedResults,
  showHeader = true,
}: {
  bracket: Bracket;
  shouldBracketExpand: boolean;
  tournamentId: string;
  gameId: GameId;
  onTeamClick?: (match: BracketSeries, team: TeamSlot | null) => void;
  pickedResults?: Record<string, TeamSlot>;
  showHeader?: boolean;
}) => {
  return (
    <Accordion className="!m-0" isExpandedByDefault={shouldBracketExpand}>
      {showHeader && (
        <Header className="hover:bg-background-85">
          {/* Bracket Header (ex. Group A...) */}
          <div className="flex flex-row items-center gap-5">
            <span className="text-white font-style-label-l4">{bracket.label}</span>
            <div className="flex h-4 items-center justify-center rounded-small bg-white px-2">
              <ClientOnly fallback={<div className="w-16" />}>
                {() => (
                  <span className="text-background-100 font-style-label-l4">
                    {getDateRangeLabel({ startDate: bracket.startDate, endDate: bracket.endDate })}
                  </span>
                )}
              </ClientOnly>
            </div>
          </div>
          <Icon isTertiary />
        </Header>
      )}
      <ContentWrapper>
        <div className="mt-2">
          {bracket.format === "double-elim-4-skewed" ? (
            <DoubleElim4Skewed
              gameId={gameId}
              bracket={bracket}
              onTeamClick={onTeamClick}
              pickedResults={pickedResults}
            />
          ) : bracket.format === "double-elim-8-groups" ? (
            <DoubleElim8Groups
              gameId={gameId}
              bracket={bracket}
              onTeamClick={onTeamClick}
              pickedResults={pickedResults}
            />
          ) : bracket.format === "double-elim-8-skewed" ? (
            <DoubleElim8Skewed
              gameId={gameId}
              bracket={bracket}
              onTeamClick={onTeamClick}
              pickedResults={pickedResults}
            />
          ) : bracket.format === "double-elim-8" ? (
            <DoubleElim8 gameId={gameId} bracket={bracket} onTeamClick={onTeamClick} pickedResults={pickedResults} />
          ) : bracket.format === "double-elim-10-skewed" ? (
            <DoubleElim10Skewed
              gameId={gameId}
              bracket={bracket}
              onTeamClick={onTeamClick}
              pickedResults={pickedResults}
            />
          ) : bracket.format === "double-elim-12-skewed" ? (
            <DoubleElim12Skewed
              gameId={gameId}
              bracket={bracket}
              onTeamClick={onTeamClick}
              pickedResults={pickedResults}
            />
          ) : bracket.format === "double-elim-16-skewed" ? (
            <DoubleElim16Skewed
              gameId={gameId}
              bracket={bracket}
              onTeamClick={onTeamClick}
              pickedResults={pickedResults}
            />
          ) : bracket.format === "single-elim-8-bounty" ? (
            <SingleElim8Bounty
              gameId={gameId}
              bracket={bracket}
              onTeamClick={onTeamClick}
              pickedResults={pickedResults}
            />
          ) : bracket.format === "single-elim-32-bounty" ? (
            <SingleElim32Bounty
              gameId={gameId}
              bracket={bracket}
              onTeamClick={onTeamClick}
              pickedResults={pickedResults}
            />
          ) : bracket.format === "gsl-8" ? (
            <Gsl8 gameId={gameId} bracket={bracket} onTeamClick={onTeamClick} pickedResults={pickedResults} />
          ) : bracket.format === "afl-final-eight" ? (
            <AFLFinalEight gameId={gameId} bracket={bracket} onTeamClick={onTeamClick} pickedResults={pickedResults} />
          ) : (
            <div className="-mt-2">
              {tournamentId && bracket.tournamentUuid && (
                <GenericPlayoffBracket
                  tournamentId={tournamentId}
                  stageId={bracket.tournamentUuid}
                  gameId={gameId}
                  bracket={bracket}
                  onTeamClick={onTeamClick}
                  pickedResults={pickedResults}
                />
              )}
            </div>
          )}
        </div>
      </ContentWrapper>
    </Accordion>
  );
};
